import React from 'react';

interface HomeIconProps {
  className?: string;
  isActive?: boolean;
  size?: number;
}

export const HomeIconTailwind: React.FC<HomeIconProps> = ({ 
  className = '', 
  isActive = false, 
  size = 20 
}) => {
  const colorClasses = isActive 
    ? 'text-[#72A8FD] group-hover:text-[#8BB8FE]' 
    : 'text-white group-hover:text-gray-200';

  return (
    <svg 
      width={size} 
      height={size * 0.95}
      viewBox="0 0 20 19" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={`${colorClasses} transition-colors duration-200 ${className}`}
    >
      <path 
        d="M10 0L0 10H2V19H18V10H20L10 0ZM10 3L16 9V17H4V9L10 3ZM9.5 12H7L10.5 5V9H13L9.5 16V12Z" 
        fill="currentColor"
      />
    </svg>
  );
}; 